import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getDrawingBysite, resetUser, fetchAllSites, getSitesDropdown } from "../../../store/actions";
import { fetchAllCategory, onAddnewDrawing } from '../../../store/manageSite/actions';
import { useForm } from '@mantine/form';
import { Table } from "@mantine/core";
import { Group } from '@mantine/core';
import { MantineGrid, MantineGridColumn } from "../../../components/mantine/grid";
import { sitedrawing_column } from "../../../helpers/columns";
import { PlaceholderUi, useCustomMediaQuery, validateimageUrlFields, validateuploadFileFields } from "../../../helpers/common";
import { useStateContext } from "../../../Contexts/ContextProvider";
import { useDisclosure } from "@mantine/hooks";
//import { useSearchParams } from 'next/navigation'
import { useParams, useNavigate } from 'react-router-dom';
import { MantineModal } from "../../../components/mantine/modal";
import { useDebounce } from "../../../utlis/debounceHook";
import CustomModalHeaderTitle from "../../../components/common/customModalHeaderTitle";
import EditDrawingPopUp from "./edit";
import DeleteConfirmation from "./delete";
import moment from "moment";
import ActionMenu from './actionMenu';
import MantineCloseButton from "../../../components/mantine/closeButton";
import MantineGroup from "../../../components/mantine/group";
import MantinePagination from "../../../components/mantine/pagination";
import MantineContainer from "../../../components/mantine/container";
import MantineTextInput from "../../../components/mantine/textinput";
import MantineSelect from "../../../components/mantine/select";
import MantineButton from "../../../components/mantine/button";
import MantineText from "../../../components/mantine/text";
import MantineFileInput from "../../../components/mantine/uploadfile";
import MantineTitle from "../../../components/mantine/title";
import { Link } from "react-router-dom";
import { EncodedUrl } from '../../../helpers/common';

const DrawingAction = () => {
    const dispatch = useDispatch();
    const [searchValue, setSearchValue] = useState<any>('');
    const [pageSize, setPageSize] = useState(5);
    const [pageNumber, setPageNumber] = useState(1);
    const [activePageNumber, setActivePageNumber] = useState(1);
    const { isLargeScreenmin, isSmallScreen } = useCustomMediaQuery();
    const [selectedRows, SetSelectedRows] = useState<any>([])
    const [opened, { open, close }] = useDisclosure(false);
    const debouncedQuery = useDebounce(searchValue, 500);
    const [openedEditPopUp, { open: openEditPopUp, close: closeEditPopUp }] = useDisclosure(false);
    const [openedDeletePopUp, { open: openDeletePopUp, close: closeDeletePopUp }] = useDisclosure(false);
    const { currentPrimaryColor, currentSecondaryColor, currentTeritorryColor } = useStateContext();
    const form = useForm({
        initialValues: {
            id: '',
            sitename: null,
            categoryname: null,
            imageUrl: '',
            title:'',
            uploadFile: null
        },
        validate: {
            sitename: (val) => (val ? null : 'Please select a SiteName '),
            title: (val) => (val ? null : 'Title is required'),
            categoryname: (val) => (val ? null : 'Please select a Category '),
            imageUrl: (value, values) => validateimageUrlFields(value, values),
            uploadFile: (value, values) => validateuploadFileFields(value, values),
        },
    });

    const { siteId } = useParams();

    const clientId = typeof window !== 'undefined' ? localStorage.getItem('SitebyClientId') : null;


    const { getsitename, getcategory, getDrawing, Count } = useSelector((state: any) => ({
        //getsitename: state.getsiteData.getSite,
        getsitename: state?.getsiteData?.sitelistdropdown,
        getcategory: state.getManualURL?.categorylist,
        getDrawing: state.getsiteData?.drawinglist,
        Count: state.getsiteData?.totalCount,
    }));

    const sitenameNames = getsitename?.map((site: any) => ({ value: String(site.siteId), label: site.siteName }));
    const categoryNames = getcategory?.map((category: any) => ({ value: String(category.id), label: category.name }));

    useEffect(() => {
        getList();
    }, [pageNumber, pageSize, siteId, clientId, debouncedQuery]);


    const getList = () => {
        const data = {
            "siteId": siteId,
           // "clientId":clientId,
            "pageNumber": pageNumber,
            "pageSize": pageSize,
            "sortColumn": "",
            "sortDirection": "",
            "searchKeyword": searchValue
        }
        dispatch(getDrawingBysite(data));
    }
    const getSiteByClient = () => {
        const data = {
            "clientId": clientId,
            "pageNumber": '1',
            "pageSize": '1000',
            "sortColumn": "",
            "sortDirection": "",
            "searchKeyword": searchValue
        }
        dispatch(getSitesDropdown(data))
    }


    useEffect(() => {
        dispatch(fetchAllCategory());
        getSiteByClient();
    }, [])

    const handleEdit = () => {
        closeEditPopUp(); form.reset();
        getList();
    }
    const handleDelete = () => {
        closeDeletePopUp();
        getList();
    }

    const handlePageSizeChange = (value: string) => {
        setPageSize(Number(value));
        setPageNumber(1);
    };
    const handleCloseValue = () => {
        setSearchValue('');
    }

    const handleResponseDrawingForm = (status: any) => {
        if (status === "SUCCESS" || status === "ADD SUCCESS") form.reset(); getList();
    }
    const handleSubmit = () => {
        if (form.isValid()) {
            const dataToSubmit = {
                ...form.values,
                clientId,
            };
            dispatch(onAddnewDrawing(dataToSubmit, handleResponseDrawingForm));
        }
    };
    const getuserReport = (reports: any) => {
        const userdata:any = {
            "siteId": siteId,           
            "sortColumn": "",
            "sortDirection": "",
            "searchKeyword": searchValue,
            isExport: true
        }
        if (!reports) {
            userdata.pageNumber = pageNumber;
            userdata.pageSize = pageSize;
        }
        if (reports == true) dispatch(getDrawingBysite(userdata, "export", `${moment(Date()).format('YYYY_MM_DD')}_drawing_list`))
    }
    const getExtensionFromUrl = (url: string): string => {
        try {
          const urlObj = new URL(url);
          const pathname = urlObj.pathname; 
          const filename = pathname.split("/").pop() || ""; 
          return filename.slice(filename.lastIndexOf(".")).toLowerCase();
        } catch (err) {
          console.error("Invalid URL:", url);
          return "";
        }
      }; 
      const handleFilePreview = async (url: string) => {
        // Open loading window immediately for better UX
        const pdfWindow = window.open("", "_blank");
        if (!pdfWindow) {
            console.error("Failed to open new window");
            return;
        }

        // Create PDF viewer with PDF.js
        pdfWindow.document.write(`
            <!DOCTYPE html>
            <html>
                <head>
                    <title>PDF Preview</title>
                    <meta charset="UTF-8">
                    <style>
                        * {
                            margin: 0;
                            padding: 0;
                            box-sizing: border-box;
                        }
                        body {
                            font-family: Arial, sans-serif;
                            background: #525252;
                            overflow: hidden;
                            display: flex;
                            flex-direction: column;
                            height: 100vh;
                        }
                        #toolbar {
                            background: #323639;
                            padding: 10px;
                            display: flex;
                            align-items: center;
                            gap: 15px;
                            color: white;
                            box-shadow: 0 2px 5px rgba(0,0,0,0.3);
                        }
                        #toolbar button {
                            background: #5f6368;
                            color: white;
                            border: none;
                            padding: 8px 15px;
                            cursor: pointer;
                            border-radius: 3px;
                            font-size: 14px;
                            transition: background 0.2s;
                        }
                        #toolbar button:hover {
                            background: #7f8388;
                        }
                        #toolbar button:disabled {
                            opacity: 0.5;
                            cursor: not-allowed;
                        }
                        #pageInfo {
                            color: white;
                            font-size: 14px;
                        }
                        #pageInput {
                            width: 50px;
                            padding: 5px;
                            text-align: center;
                            border: none;
                            border-radius: 3px;
                        }
                        #viewer-container {
                            flex: 1;
                            overflow: auto;
                            display: flex;
                            justify-content: center;
                            padding: 20px;
                        }
                        #pdf-canvas {
                            box-shadow: 0 2px 10px rgba(0,0,0,0.5);
                            background: white;
                        }
                        #loading {
                            position: absolute;
                            top: 50%;
                            left: 50%;
                            transform: translate(-50%, -50%);
                            text-align: center;
                            color: white;
                        }
                        .spinner {
                            border: 4px solid #f3f3f3;
                            border-top: 4px solid #3498db;
                            border-radius: 50%;
                            width: 50px;
                            height: 50px;
                            animation: spin 1s linear infinite;
                            margin: 0 auto 20px;
                        }
                        @keyframes spin {
                            0% { transform: rotate(0deg); }
                            100% { transform: rotate(360deg); }
                        }
                        .hidden {
                            display: none;
                        }
                    </style>
                </head>
                <body>
                    <div id="toolbar">
                        <button id="prev-page">Previous</button>
                        <button id="next-page">Next</button>
                        <span id="pageInfo">
                            Page <input type="number" id="pageInput" min="1" value="1"> of <span id="page-count">-</span>
                        </span>
                        <button id="zoom-in">Zoom In</button>
                        <button id="zoom-out">Zoom Out</button>
                        <button id="zoom-reset">Reset Zoom</button>
                    </div>
                    <div id="viewer-container">
                        <div id="loading">
                            <div class="spinner"></div>
                            <div>Loading PDF...</div>
                        </div>
                        <canvas id="pdf-canvas"></canvas>
                    </div>

                    <script src="https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.min.js"></script>
                    <script>
                        // Configure PDF.js worker
                        pdfjsLib.GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js';

                        let pdfDoc = null;
                        let currentPage = 1;
                        let scale = 1.5;
                        const canvas = document.getElementById('pdf-canvas');
                        const ctx = canvas.getContext('2d');
                        const loading = document.getElementById('loading');

                        // Fetch and render PDF
                        async function loadPDF() {
                            try {
                                const response = await fetch('${url}');
                                if (!response.ok) throw new Error('Failed to fetch PDF');

                                const arrayBuffer = await response.arrayBuffer();
                                const loadingTask = pdfjsLib.getDocument({data: arrayBuffer});

                                pdfDoc = await loadingTask.promise;
                                document.getElementById('page-count').textContent = pdfDoc.numPages;

                                loading.classList.add('hidden');
                                renderPage(currentPage);
                            } catch (error) {
                                console.error('Error loading PDF:', error);
                                loading.innerHTML = '<div style="color: #ff6b6b;">Failed to load PDF: ' + error.message + '</div>';
                            }
                        }

                        async function renderPage(num) {
                            try {
                                const page = await pdfDoc.getPage(num);
                                const viewport = page.getViewport({scale: scale});

                                canvas.height = viewport.height;
                                canvas.width = viewport.width;

                                const renderContext = {
                                    canvasContext: ctx,
                                    viewport: viewport
                                };

                                await page.render(renderContext).promise;

                                currentPage = num;
                                document.getElementById('pageInput').value = num;
                                updateButtons();
                            } catch (error) {
                                console.error('Error rendering page:', error);
                            }
                        }

                        function updateButtons() {
                            document.getElementById('prev-page').disabled = currentPage <= 1;
                            document.getElementById('next-page').disabled = currentPage >= pdfDoc.numPages;
                        }

                        // Event listeners
                        document.getElementById('prev-page').addEventListener('click', () => {
                            if (currentPage > 1) renderPage(currentPage - 1);
                        });

                        document.getElementById('next-page').addEventListener('click', () => {
                            if (currentPage < pdfDoc.numPages) renderPage(currentPage + 1);
                        });

                        document.getElementById('pageInput').addEventListener('change', (e) => {
                            const pageNum = parseInt(e.target.value);
                            if (pageNum >= 1 && pageNum <= pdfDoc.numPages) {
                                renderPage(pageNum);
                            } else {
                                e.target.value = currentPage;
                            }
                        });

                        document.getElementById('zoom-in').addEventListener('click', () => {
                            scale += 0.25;
                            renderPage(currentPage);
                        });

                        document.getElementById('zoom-out').addEventListener('click', () => {
                            if (scale > 0.5) {
                                scale -= 0.25;
                                renderPage(currentPage);
                            }
                        });

                        document.getElementById('zoom-reset').addEventListener('click', () => {
                            scale = 1.5;
                            renderPage(currentPage);
                        });

                        // Keyboard navigation
                        document.addEventListener('keydown', (e) => {
                            if (e.key === 'ArrowLeft' && currentPage > 1) {
                                renderPage(currentPage - 1);
                            } else if (e.key === 'ArrowRight' && currentPage < pdfDoc.numPages) {
                                renderPage(currentPage + 1);
                            }
                        });

                        // Load PDF on page load
                        loadPDF();
                    </script>
                </body>
            </html>
        `);
        pdfWindow.document.close();
    }; 
    const handleimagePreview = async (url: string) => {
        const imageWindow = window.open("");
        if (imageWindow) {
            imageWindow.document.write(`
                <html>
                    <head><title>Image Preview</title></head>
                    <body style="margin:0; display:flex; justify-content:center; align-items:center; height:100vh;">
                        <img src="${url}" style="max-width:100%; max-height:100%;" />
                    </body>
                </html>
            `);
        }
    };
   
    const rows = getDrawing?.map((item: any) => (
        <Table.Tr key={item.id}>
            <Table.Td data-label="Site Name">{item.siteName}</Table.Td>
            <Table.Td data-label="Category Name">{item.categoryName}</Table.Td>
            <Table.Td data-label="Title">{item?.title}</Table.Td>
            <Table.Td data-label="Image Path"> {item.imageUrl && item.imageUrl !== null ? (<Link to={item.imageUrl} style={{ textDecoration: 'underline' }}  target="_blank" rel="noopener noreferrer"> {item.imageUrl} </Link>) : 'N/A'}</Table.Td>       
            <Table.Td data-label="File Upload">
                {
                    item.uploadFile ? (
                        (() => {
                            let displayText = item.uploadFile;
                            const urlObj = new URL(item.uploadFile);
                            const fileName = urlObj.searchParams.get("fileName");
                            if (fileName && fileName.length > 0) {
                                displayText = fileName;
                            }

                            return (
                                <span
                                    style={{ textDecoration: 'underline', cursor: 'pointer' }}
                                    onClick={() => {
                                        const url = new URL(item.uploadFile);
                                        const fileName = url.searchParams.get("fileName") || "";
                                        const extension = fileName.slice(fileName.lastIndexOf(".")).toLowerCase();
                                        const encodedUrl = EncodedUrl(
                                            fileName,
                                            item.siteName,
                                            item.clientName,
                                            item.categoryName
                                        );
                                        const imagepath = getExtensionFromUrl(encodedUrl);
                                        const imageExtensions = [".jpg", ".jpeg", ".png", ".gif", ".bmp", ".webp"];
                                        const pdfExtension = ".pdf";
                                        const wordExtensions = [".doc", ".docx", ".xls", ".xlsx"];
                                        const dwgExtension = ".dwg"; 
                                     
                                        if (imageExtensions.includes(extension)) {                                   
                                            handleimagePreview(encodedUrl);
                                        } else if (extension === pdfExtension) {                                        
                                            handleFilePreview(encodedUrl);
                                        } else if (wordExtensions.includes(extension)) {
                                            const officeViewerUrl = `https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(encodedUrl)}`;
                                            window.open(officeViewerUrl, "_blank");
                                        }
                                        else{
                                            window.open(item.uploadFile, "_blank");
                                        }
                                    }}
                                >
                                    {displayText} 
                                </span>
                            );
                        })()
                    ) : 'N/A' 
                }
            </Table.Td>
            <Table.Td data-label="Action">
                <ActionMenu
                    item={item}
                    open={open}
                    openEditPopUp={openEditPopUp}
                    openDeletePopUp={openDeletePopUp}
                    SetSelectedRows={SetSelectedRows}
                />

            </Table.Td>
        </Table.Tr>
    ));
    const classButton = `w-fit text-sm font-thin  ${isSmallScreen && 'w-full'}`;
    return (
        <div className="w-full mt-4">
            {/* <MantineTitle order={4} className="m-auto font-semibold text-md text-center">ManageSite Drawing</MantineTitle>  */}
            <MantineContainer fluid={true} className="bg-white my-6 px-5">
                <MantineGrid className="py-5" grow={true}>
                    <Group className="flex justify-between w-full">
                        <Group className="flex-row ">
                            <form onSubmit={(event: any) => { event.preventDefault(); setPageNumber(1); getList() }}>
                                <MantineTextInput
                                    placeholder="Search by Title or Category Name"
                                    onChange={(event: any) => setSearchValue(event.currentTarget.value)}
                                    value={searchValue}
                                    rightSection={searchValue.length >= 1 && <MantineCloseButton onClick={handleCloseValue} />}
                                    classNames={{ input: `${PlaceholderUi} w-[300px] ml-3` }}
                                />
                            </form>
                            <MantineButton
                                color={currentPrimaryColor}
                                className="w-fit text-sm font-thin"
                                onClick={getList}
                                classNames={classButton}
                            >
                                Search
                            </MantineButton>

                        </Group>

                        <form onSubmit={form.onSubmit(handleSubmit)} className="flex flex-col gap-4">
                            <div className="flex justify-between">
                                <MantineSelect
                                    label="Select Site"
                                    required
                                    placeholder="Select From Dropdown"
                                    data={sitenameNames}
                                    value={form.values.sitename}
                                    onChange={(value: any) => form.setFieldValue('sitename', value)}
                                    classNames={{ input: 'w-[363px] h-[40px]  bg-white border border-gray-400 rounded-[40px]' }}
                                    error={form.errors.sitename}
                                />
                                <MantineSelect
                                    label="Select Category"
                                    required
                                    placeholder="Select From Dropdown"
                                    data={categoryNames}
                                    value={form.values.categoryname}
                                    onChange={(value: any) => form.setFieldValue('categoryname', value)}
                                    classNames={{ input: 'w-[363px] h-[40px]  bg-white border border-gray-400 rounded-full' }}
                                    error={form.errors.categoryname}
                                />
                            </div>
                            <div className="flex justify-between items-center">
                                <div className="flex flex-col flex-1 mr-4">
                                    <MantineTextInput
                                        //label="Image Path"
                                        placeholder="Enter Your Path"
                                        label={<span>Image Path <span style={{ color: 'red' }}>*</span></span>}
                                        value={form.values.imageUrl}
                                        onChange={(event: any) => form.setFieldValue('imageUrl', event.currentTarget.value)}
                                        classNames={{ input: 'w-[363px] h-[40px] bg-white border border-gray-400 rounded-[40px]' }}
                                        error={form.errors.imageUrl}
                                    />
                                </div>
                                <div className="flex items-center justify-center mx-4">
                                    <MantineText className="text-sm font-medium ">
                                        (or)
                                    </MantineText>
                                </div>
                                <div className="flex flex-col flex-1 ml-4">
                                    <MantineFileInput
                                        {...form.getInputProps('uploadFile')}
                                        label={<span>File Upload <span style={{ color: 'red' }}>*</span></span>}
                                        multiple
                                        placeholder="Upload Your File"
                                        classNames={{ input: 'w-[363px] h-[40px] bg-white border border-gray-400 rounded-full pr-10' }}
                                        error={form.errors.uploadFile}
                                        page="drawing"
                                    />
                                </div>
                            </div>
                            <div className="flex flex-col mb-4">
                                <MantineTextInput
                                    label={<span>Title <span style={{ color: 'red' }}>*</span></span>}
                                    placeholder="Enter the title"
                                    value={form.values.title}
                                    onChange={(event: any) => form.setFieldValue('title', event.currentTarget.value)}
                                    classNames={{ input: 'w-[363px] h-[40px] bg-white border border-gray-400 rounded-[40px]' }}
                                    error={form.errors.title}
                                />
                            </div>
                            <div className="flex justify-center">
                                <MantineButton
                                    type="submit"
                                    className="w-[140px] h-[40px] bg-[#2F7FE2] rounded-[40px] text-sm font-thin text-white mt-2"
                                    style={{
                                        fontFamily: 'Gantari, sans-serif',
                                        fontWeight: 'bold',
                                        fontSize: '14px',
                                        lineHeight: '16px',
                                    }}
                                >
                                    SUBMIT
                                </MantineButton>
                            </div>
                        </form>


                        <MantineGroup justify="flex-end" >
                            <MantineButton
                                name={'Export'}
                                color={currentPrimaryColor}
                                onClick={() => getuserReport(true)}

                                className={classButton}
                            />
                        </MantineGroup>
                    </Group>

                </MantineGrid>

            </MantineContainer>

            <MantineContainer fluid={true} className="m-auto bg-white pt-5 px-5 pb-10">
                <div className={`${rows?.length !== 0 && 'mobile-responsive-scroll'}`}>
                    <Table className="bg-global_bg" verticalSpacing="sm">
                        <Table.Thead>
                            <Table.Tr>
                                {sitedrawing_column?.map((data: any) => (
                                    <Table.Th key={data.id}>{data.name}</Table.Th>
                                ))}
                            </Table.Tr>
                        </Table.Thead>
                        <Table.Tbody className="relative">
                            {rows?.length === 0 ? (
                                <Table.Tr>
                                    <Table.Td colSpan={sitedrawing_column.length} className={`${isLargeScreenmin ? 'mt-4 text-center' : 'text-center'}`}>
                                        No Data Found
                                    </Table.Td>
                                </Table.Tr>
                            ) : rows}
                        </Table.Tbody>
                    </Table>
                </div>

                <MantineGroup className={`justify-end pt-5 ${rows?.length == 0 && isLargeScreenmin && 'pb-8'}`}>
                    {rows?.length > 0 && (
                        <MantinePagination
                            total={Math.ceil(Count / pageSize)}
                            onChange={(value: any) => { setPageNumber(value); setActivePageNumber(value) }}
                            color={currentPrimaryColor}
                            withEdges={true}
                            valueSelect={pageSize}
                            size="md"
                            className='m-auto pb-4'
                            onChangeSelect={handlePageSizeChange}
                            value={searchValue?.length != 0 ? pageNumber : activePageNumber}

                        />

                    )}
                </MantineGroup>
            </MantineContainer>


            <MantineModal opened={openedEditPopUp} onClose={closeEditPopUp} title={<CustomModalHeaderTitle title='Edit' onClick={closeEditPopUp} />}>
                <EditDrawingPopUp category={selectedRows} modalclose={closeEditPopUp} dispatch={dispatch} handleEdit={handleEdit} currentPrimaryColor={currentPrimaryColor} currentSecondaryColor={currentSecondaryColor}
                    sitenameNames={sitenameNames} categoryNames={categoryNames} clientId={clientId}
                />
            </MantineModal>
            <MantineModal opened={openedDeletePopUp} onClose={closeDeletePopUp} title={<CustomModalHeaderTitle title='Delete' onClick={closeDeletePopUp} />}>
                <DeleteConfirmation category={selectedRows} modalclose={closeDeletePopUp} handleDelete={handleDelete} currentPrimaryColor={currentPrimaryColor} currentSecondaryColor={currentSecondaryColor}
                />
            </MantineModal>

        </div>
    );
};

export default DrawingAction;
